export default {
    SetQueryParams   : "SET_QUERY_PARAMS",
    AddQueryParam    : "ADD_QUERY_PARAM",
    RemoveQueryParam : "REMOVE_QUERY_PARAM"
}
